import { getImpersonationHeader } from './impersonation';

const baseUrl = '/api/persona/v2';

/**
 * Fetches the access packages for the user.
 * @param token - The access token for authentication.
 * @returns An array of package codes.
 */
export const getAccessPackages = async (token: string) => {
  try {
    const impersonationHeader = getImpersonationHeader();
    const response = await fetch(`${baseUrl}/package`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...impersonationHeader,
      },
    });

    const json = await response.json();
    const packageCodes = json?.package_code || [];

    return packageCodes;
  } catch (error) {
    console.error('Error in getAccessPackages:', error);
    throw error;
  }
};
